export const ar = {
  translation: {
    seo: {
      defaults: {
        siteName: 'فاتي قفطان',
        description: 'ورشة حرفية مغربية — قفاطين، تكشيطات، جلابات بالتفصيل والجاهز للارتداء. خياطة تقليدية، تطريز يدوي، تشطيب متقن.'
      },
      organization: {
        description: 'ورشة خياطة تقليدية مغربية — قفاطين، تكشيطات، جلابات وقطع جاهزة للارتداء، مخيطة يدوياً في المغرب.'
      },
      home: {
        title: 'قفاطين وخياطة تقليدية مغربية',
        description: 'اكتشفي مجموعة فاتي قفطان: قفاطين، تكشيطات وجلابات مخيطة يدوياً في المغرب. تفصيل خاص أو جاهز للارتداء، حجز المواعيد عبر الإنترنت.'
      },
      productDetail: {
        title: 'تفاصيل القطعة',
        description: 'قطعة حرفية من فاتي قفطان — مخيطة يدوياً مع تطريز تقليدي. احجزي عبر واتساب أو موعد للقياس.'
      },
      about: {
        title: 'عن الورشة',
        description: 'قصة وحرفية ورشة فاتي قفطان، المختصة في الخياطة التقليدية المغربية.'
      },
      contact: {
        title: 'اتصلي بنا',
        description: 'تواصلي مع ورشة فاتي قفطان عبر البريد، الهاتف أو واتساب لأي سؤال حول القطع، المواعيد أو الحجوزات.'
      },
      faq: {
        title: 'الأسئلة الشائعة',
        description: 'كل ما تحتاجين معرفته قبل طلب قطعة بالتفصيل أو حجز قفطان جاهز للارتداء في فاتي قفطان.'
      },
      terms: {
        title: 'الشروط',
        description: 'الشروط العامة المطبقة على استخدام موقع فاتي قفطان.'
      },
      legal: {
        title: 'البيانات القانونية',
        description: 'البيانات القانونية لموقع فاتي قفطان — الناشر، المستضيف، الملكية الفكرية والاتصال.'
      },
      cgv: {
        title: 'شروط الخدمة',
        description: 'شروط حجز المواعيد والقطع في ورشة فاتي قفطان.'
      },
      privacy: {
        title: 'سياسة الخصوصية',
        description: 'حماية البيانات الشخصية في فاتي قفطان — وفقاً للقانون المغربي 09-08 والنظام الأوروبي العام لحماية البيانات.'
      },
      notFound: {
        title: 'الصفحة غير موجودة',
        description: 'الصفحة المطلوبة غير موجودة أو تم نقلها.'
      },
      underConstruction: {
        title: 'قريباً',
        description: 'فاتي قفطان بصدد إتمام متجرها الإلكتروني. تواصلي عبر واتساب لمعرفة المزيد.'
      }
    },
    header: {
      title: 'الخياطة المخصصة',
      languages: {
        en: 'الإنجليزية',
        fr: 'الفرنسية',
        ar: 'العربية'
      }
    },
    underConstruction: {
      kicker: 'الورشة · المغرب',
      badge: 'قريباً',
      title: {
        line1: 'اللمسات الأخيرة',
        line2: 'قيد الإنجاز.'
      },
      subtitle: 'الورشة في طور إتمام متجرها الإلكتروني. قفاطين، تكشيطات، جلابات وقطع جاهزة للارتداء — مخيطة يدوياً بالمغرب. تواصلي معنا اليوم عبر واتساب لحجز استشارة أو لمعرفة المزيد.',
      contactCta: 'تواصلي معنا عبر واتساب',
      contactHint: 'الرد خلال 24 ساعة.',
      expected: {
        label: 'الطلبات',
        value: 'مفتوحة الآن عبر واتساب'
      },
      workshop: {
        label: 'الورشة',
        value: 'قطع فريدة مخيطة يدوياً، تطريز تقليدي، تفصيل خاص أو جاهز للارتداء.'
      },
      footer: '© {{year}} فاتي قفطان — جميع الحقوق محفوظة.',
      whatsapp: {
        message: 'مرحباً، وصلت إليكم من موقع faticaftan.com — أود معرفة المزيد عن قطعكم.'
      }
    },
    nav: {
      home: 'الرئيسية',
      dashboard: 'لوحة التحكم',
      appointments: 'المواعيد',
      calendar: 'التقويم',
      products: 'المنتجات',
      analytics: 'الزوار',
      cart: 'السلة',
      login: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      openMenu: 'فتح القائمة',
      closeMenu: 'إغلاق القائمة'
    },
    adminAnalytics: {
      title: 'الزوار',
      subtitle: 'حركة زيارات الموقع، محسوبة من سجلات الخادم. بدون أي سكربت تتبّع ولا كوكيز.',
      loading: 'جارٍ تحميل الأرقام…',
      visitors: 'زوار فريدون',
      pageViews: 'صفحات مشاهدة',
      period: 'الفترة',
      dailyRefresh: 'يُحدَّث مرة في اليوم',
      daily: 'الزيارات يوميًا',
      dailyChartLabel: 'رسم بياني للزيارات اليومية',
      noDaily: 'لا توجد بيانات يومية بعد.',
      topPages: 'الصفحات الأكثر مشاهدة',
      referrers: 'مصادر الزيارات',
      countries: 'البلدان',
      noData: 'لا توجد بيانات.',
      noCountries: 'قاعدة بيانات البلدان غير متوفرة — أعد تشغيل السكربت بـ ACTION=geoip.',
      unavailableMock: 'الأرقام غير متاحة في وضع العرض التجريبي: لا توجد بيانات حقيقية.',
      botNote: 'تُستبعد الروبوتات المعلنة ومراقبة التوفّر وعمليات الفحص. يبقى بعض التصفّح الآلي على الصفحة الرئيسية.'
    },
    calendar: {
      title: 'التقويم',
      subtitle: 'عرض شهري لجميع المواعيد.',
      prev: 'الشهر السابق',
      next: 'الشهر التالي',
      today: 'اليوم',
      more: 'المزيد'
    },
    dashboard: {
      title: 'لوحة التحكم',
      subtitle: 'نظرة عامة على المواعيد ونشاط الكتالوج.',
      viewAll: 'عرض الكل',
      stats: {
        pending: 'قيد الانتظار',
        confirmed: 'مؤكدة',
        completed: 'منتهية',
        cancelled: 'ملغاة',
        products: 'المنتجات'
      },
      upcoming: {
        title: 'القادمة (7 أيام)',
        empty: 'لا توجد مواعيد في الأيام السبعة القادمة.'
      },
      recent: {
        title: 'الطلبات الأخيرة',
        empty: 'لا توجد طلبات حتى الآن.'
      }
    },
    confirm: {
      confirm: 'تأكيد',
      cancel: 'إلغاء'
    },
    login: {
      title: 'تسجيل دخول المسؤول',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      submit: 'دخول',
      submitting: 'جارٍ الدخول…',
      mockHint: {
        title: 'بيانات اختبار (للتطوير فقط)'
      }
    },
    hero: {
      title: 'التميز في الخياطة المخصصة',
      subtitle: 'احجز موعد القياس المهني اليوم. يضمن خياطونا المحترفون مقاسات مثالية وجودة استثنائية لملابسك المخصصة.',
      kicker: 'بيت الأزياء — المغرب',
      titleLine1: 'الليل',
      titleAccent1: 'إطار',
      titleLine2: '، والقفطان',
      titleLine3: 'هو',
      titleAccent2: 'توقيعك.',
      lede: 'خمسة عشر عاماً من العمل في الورشة المغربية. حرير، بروكار، تطريز بخيط الذهب. كل قطعة فريدة من نوعها — قطعتك، نخيطها بعد أن نلتقي بكِ.',
      ctaPrimary: 'احجزي موعداً',
      ctaSecondary: 'اكتشفي المجموعات',
      refNumber: 'رقم 00',
      refLabel: 'العدد التأسيسي'
    },
    atelier: {
      kicker: 'رقم 05 — الورشة',
      titleLine1: 'بيت',
      titleAccent: 'واحد',
      titleLine2: '، توقيع واحد.',
      body1: 'تعلّمت فاطمة الخياطة إلى جانب والدتها في بيت من بيوت مدينة فاس العتيقة، في سنّ كان الأخريات يلعبن فيه بعد. بعد خمسة عشر عاماً، ترسم كلَّ قطعة بالحبر البنيّ على ورق الكرافت، تختار أقمشتها من باب بوجلود، وتُسلّم التطريز لدائرة من الحرفيات تعرفهنّ بأسمائهنّ.',
      body2: 'كل قفطان يخضع لتقويم من ثمانية أسابيع على الأقل. لا مخزون، لا إنتاج كبير. الفخامة هنا هي الوقت الذي نمنحه لك.',
      stats: {
        yearsValue: '15',
        yearsLabel: 'سنة من الورشة',
        piecesValue: '+200',
        piecesLabel: 'قطعة مُسلَّمة',
        citiesValue: '2',
        citiesLabel: 'الدار البيضاء · مراكش'
      }
    },
    waStrip: {
      titleLine1: 'سؤال،',
      titleAccent: 'طلب',
      titleLine2: 'خاص؟',
      subtitle: 'راسلي الورشة على واتساب — جواب خلال 24 ساعة، بالفرنسية والعربية والإنجليزية.',
      cta: 'مراسلة الورشة'
    },
    share: {
      button: 'مشاركة',
      copiedToast: 'تم نسخ الرابط',
      copyFailed: 'تعذّر نسخ الرابط.',
      instagramHint: 'تم نسخ الرابط — الصقيه في قصتك على إنستغرام',
      targets: {
        whatsapp: 'واتساب',
        facebook: 'فيسبوك',
        pinterest: 'بنترست',
        instagram: 'إنستغرام (نسخ)',
        email: 'البريد الإلكتروني',
        copy: 'نسخ الرابط'
      }
    },
    story: {
      button: 'تصميم قصة إنستغرام',
      generating: 'جاري الإنشاء…',
      success: 'تم تنزيل صورة القصة — انشريها على قصتك.',
      error: 'تعذّر إنشاء صورة القصة'
    },
    currency: {
      label: 'العملة',
      indicative: '≈ سعر تقريبي',
      codes: {
        MAD: 'درهم (MAD)',
        EUR: 'يورو (EUR)',
        USD: 'دولار (USD)'
      }
    },
    product: {
      duration: 'مدة القياس',
      viewDetails: 'عرض التفاصيل',
      scheduleButton: 'حجز موعد القياس',
      shopButton: 'اطلب الآن',
      reserveButton: 'احجزي',
      readyToWearBadge: 'جاهز للارتداء'
    },
    cart: {
      title: 'سلة التسوق',
      itemCount: '{{count}} منتج(ات) في السلة',
      sizeLabel: 'المقاس',
      increase: 'زيادة الكمية',
      decrease: 'إنقاص الكمية',
      remove: 'إزالة',
      checkoutCta: 'إتمام الطلب',
      continueShopping: 'متابعة التسوق',
      empty: {
        title: 'سلتك فارغة',
        description: 'تصفحي مجموعة الجاهز للارتداء وأضيفي القطع هنا.',
        cta: 'عرض الكتالوج'
      },
      summary: {
        title: 'الملخص',
        subtotal: 'المجموع الفرعي',
        shipping: 'الشحن',
        shippingHint: 'يُحدد عبر واتساب',
        total: 'الإجمالي'
      },
      toast: {
        added: 'تمت الإضافة إلى السلة (مقاس {{size}})'
      }
    },
    checkout: {
      title: 'إتمام الطلب',
      subtitle: 'سيتم إرسال بياناتك إلى الخياطة عبر واتساب لتأكيد التوفر وتنظيم التوصيل.',
      backToCart: 'العودة إلى السلة',
      submitCta: 'إرسال عبر واتساب',
      success: 'تم إرسال الطلب — ستتواصل معك الخياطة قريباً.',
      disclaimer: 'يتم الدفع والتوصيل مباشرة مع الخياطة عبر واتساب.',
      fields: {
        fullName: 'الاسم الكامل',
        phone: 'الهاتف',
        city: 'المدينة',
        address: 'عنوان التوصيل',
        notes: 'ملاحظة (اختياري)'
      },
      errors: {
        required: 'مطلوب',
        invalidPhone: 'رقم غير صالح'
      },
      whatsapp: {
        header: 'مرحباً، أود تأكيد الطلب التالي:',
        itemsHeader: 'القطع:',
        total: 'الإجمالي',
        footer: 'يرجى تأكيد التوفر وطريقة التوصيل.'
      }
    },
    form: {
      title: 'جدولة موعد القياس',
      about: {
        title: 'حول عملية القياس',
        description: 'تضمن خدمة القياس المهنية لدينا مقاسات مثالية وتخصيصًا كاملاً. سيقوم متخصص ماهر بأخذ قياسات دقيقة باستخدام أدوات متطورة.',
        duration: 'المدة'
      },
      fields: {
        name: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        phone: 'رقم الهاتف',
        date: 'التاريخ المفضل',
        time: 'الوقت المفضل',
        notes: 'متطلبات خاصة أو ملاحظات',
        notesPlaceholder: 'أي متطلبات خاصة أو معلومات إضافية...'
      },
      timeSlots: {
        morning: 'صباحاً',
        afternoon: 'ظهراً',
        evening: 'مساءً'
      },
      buttons: {
        cancel: 'إلغاء',
        confirm: 'تأكيد الموعد'
      },
      success: 'تم جدولة الموعد بنجاح! سوف تتلقى رسالة تأكيد عبر البريد الإلكتروني قريباً.',
      errors: {
        nameTooShort: 'يرجى إدخال اسمك الكامل (حرفان على الأقل).',
        emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح.',
        phoneInvalid: 'يرجى إدخال رقم هاتف صحيح.',
        dateRequired: 'يرجى اختيار التاريخ.',
        timeRequired: 'يرجى اختيار الوقت.',
        slotConflict: 'تم حجز هذا الموعد لتوّه. يرجى اختيار موعد آخر.'
      },
      slots: {
        fullyBooked: 'مكتمل',
        taken: 'محجوز'
      }
    },
    catalog: {
      search: {
        label: 'بحث في الكتالوج',
        placeholder: 'بحث بالاسم أو الوصف…'
      },
      category: {
        label: 'الفئة',
        values: {
          ALL: 'الكل',
          CAFTAN: 'قفطان',
          TAKCHITA: 'تكشيطة',
          DJELLABA: 'جلابة',
          OTHER: 'أخرى'
        }
      },
      type: {
        label: 'طريقة الشراء',
        values: {
          ALL: 'الكل',
          CUSTOM: 'تفصيل خاص',
          READY_TO_WEAR: 'جاهز للارتداء'
        }
      },
      minPrice: 'السعر الأدنى',
      maxPrice: 'السعر الأقصى',
      sort: {
        label: 'ترتيب حسب',
        relevance: 'الأهمية',
        priceAsc: 'السعر: الأدنى أولاً',
        priceDesc: 'السعر: الأعلى أولاً',
        ratingDesc: 'الأعلى تقييماً'
      },
      clear: 'مسح',
      empty: 'لا توجد منتجات تطابق الفلاتر.',
      count: '{{count}} من {{total}} منتجات',
      sections: {
        emptyCategory: 'لا توجد قطع متوفرة في هذه الفئة حالياً.',
        caftan: {
          num: '01',
          numLabel: 'الفئة',
          titleLine1: 'القفاطين',
          titleAccent: 'الفاخرة',
          titleLine2: '.',
          subtitle: 'قطع مفصّلة للعرائس والمناسبات الكبرى.',
          countLabel: 'قطعة · حسب المقاس',
          metaLine1: 'تفصيل · 8 أسابيع',
          metaLine2: '3 قياسات'
        },
        takchita: {
          num: '02',
          numLabel: 'الفئة',
          titleLine1: 'التكشيطات',
          titleAccent: 'الراقية',
          titleLine2: '.',
          subtitle: 'قطعتان وزمنان. لأرقى السهرات.',
          countLabel: 'قطعة · حسب المقاس',
          metaLine1: 'تفصيل · 10 أسابيع',
          metaLine2: 'مع حزام ذهبي'
        },
        djellaba: {
          num: '03',
          numLabel: 'الفئة',
          titleLine1: 'الجلابيات',
          titleAccent: 'اليومية',
          titleLine2: '.',
          subtitle: 'أناقة يومية، جاهزة أو مفصّلة باليد.',
          countLabel: 'قطعة · حسب المقاس',
          metaLine1: 'جاهز · من المخزون',
          metaLine2: 'تفصيل · 4 أسابيع'
        },
        readyToWear: {
          num: '04',
          numLabel: 'الفئة',
          titleLine1: 'الجاهز',
          titleAccent: 'للارتداء',
          titleLine2: '.',
          subtitle: 'قطع متوفرة فوراً، مقاسات XS إلى XXL.',
          countLabel: 'قطعة · مخزون',
          metaLine1: 'التوصيل · 7 أيام',
          metaLine2: 'الاستبدال خلال 14 يوماً'
        }
      },
      scrollPrev: 'السابق',
      scrollNext: 'التالي'
    },
    whatsapp: {
      aria: 'تواصل عبر واتساب',
      message: 'مرحباً، أودّ معرفة المزيد عن قطعكم المفصّلة.'
    },
    testimonials: {
      kicker: '— شهادات',
      title: 'همسات من الورشة',
      subtitle: 'ما تقوله من ارتدين قطعنا.',
      items: {
        one: {
          name: 'ياسمين أ.',
          city: 'الدار البيضاء',
          quote: 'قصّة مثالية ليوم زفافي. كل تفصيل أُنجز يدوياً بصبر نادر.'
        },
        two: {
          name: 'سلمى ب.',
          city: 'الرباط',
          quote: 'الإصغاء والاهتمام بالتفاصيل أسرّاني. قفطاني يقع كأنه جلد ثانٍ.'
        },
        three: {
          name: 'نورا إ.',
          city: 'مراكش',
          quote: 'خدمة استثنائية من أول قياس إلى التسليم. أوصي بها بثقة.'
        },
        four: {
          name: 'إيناس د.',
          city: 'باريس',
          quote: 'قطعة فريدة حقاً لعرس في فاس. النتيجة فاقت توقعاتي.'
        }
      }
    },
    notFound: {
      kicker: 'خطأ · 404',
      titleLine1: 'هذه الصفحة',
      titleLine2: 'قد ضلّت الطريق.',
      subtitle: 'قد يكون الرابط الذي تبعته قديماً، أو أن القطعة التي تبحث عنها قد غادرت الورشة. لنبدأ من جديد.',
      requestedPath: 'المسار المطلوب',
      backHome: 'العودة إلى الرئيسية',
      suggestions: {
        catalog: 'تصفّح الكتالوج',
        about: 'اكتشف الورشة',
        contact: 'تواصل معنا'
      }
    },
    productDetail: {
      back: 'العودة إلى الكتالوج',
      gallery: 'معرض الصور',
      thumbnailAlt: 'صورة {{n}} من {{title}}',
      from: 'يبدأ من',
      rating: 'التقييم',
      durationLabel: 'مدة القياسات',
      detailsTitle: 'تفاصيل القطعة',
      reserveCta: 'حجز موعد للقياسات',
      sizeLabel: 'المقاس',
      addToCart: 'أضف إلى السلة',
      buyNow: 'اشترِ الآن',
      reserveOnWhatsApp: 'احجزي عبر واتساب',
      reserveOnWhatsAppHint: 'تواصل مباشر — الدفع نقداً عند الاستلام أو بتحويل بنكي.',
      reserveWhatsAppMessage: 'مرحباً، أود حجز « {{title}} » بمقاس {{size}} ({{price}} درهم). هل القطعة متوفرة؟',
      outOfStock: 'غير متوفر',
      notFound: 'المنتج غير موجود.',
      loading: 'جارٍ التحميل…'
    },
    footer: {
      tagline: 'ملابس مفصّلة يدوياً في باريس منذ 2014.',
      explore: 'استكشف',
      contact: 'اتصل بنا',
      hours: 'ساعات العمل',
      weekdays: 'الإثنين – الجمعة: 10:00 – 19:00',
      saturday: 'السبت: 11:00 – 18:00',
      sunday: 'الأحد: مغلق',
      rights: 'جميع الحقوق محفوظة.',
      links: {
        about: 'من نحن',
        contact: 'اتصل بنا',
        terms: 'الشروط',
        cgv: 'شروط الخدمة',
        privacy: 'الخصوصية',
        legal: 'البيانات القانونية',
        faq: 'الأسئلة الشائعة'
      }
    },
    faq: {
      kicker: 'الأسئلة الشائعة',
      titleLine1: 'كل ما تحتاجين معرفته',
      titleLine2: 'قبل موعدك.',
      subtitle: 'إجابات عن أكثر الأسئلة شيوعاً حول قطعنا والقياسات والمواعيد.',
      cta: {
        lead: 'سؤال لا تجدينه هنا؟',
        button: 'راسلينا'
      },
      items: {
        appointment: {
          question: 'كيف أحجز موعداً للقياسات؟',
          answer: 'اختاري القطعة التي تعجبك من الكتالوج ثم اضغطي «حجز موعد». اختاري التاريخ والوقت (صباح، ظهر، أو مساء). ستصلك رسالة تأكيد خلال 24 ساعة.'
        },
        measurement: {
          question: 'كيف تجري جلسة القياسات؟',
          answer: 'تقوم حرفية مؤهلة بأخذ نحو عشرين قياساً دقيقاً باستخدام أدوات احترافية. كما تنصحك بالأقمشة والقصّات والتشطيبات الملائمة لجسمك وللمناسبة.'
        },
        duration: {
          question: 'متى أستلم قطعتي؟',
          answer: 'تحتاج القفطان أو التكشيطة الكاملة من 4 إلى 6 أسابيع، والجلابة أو القطع البسيطة من 2 إلى 3 أسابيع. للأعراس، احسبي 8 أسابيع على الأقل لاستيعاب جلسات القياس المتعددة.'
        },
        fabric: {
          question: 'هل أستطيع اختيار قماشي بنفسي؟',
          answer: 'نعم. نعمل بحرير ومسلين وبروكار وأقمشة صوفية مختارة من مورّدين مغاربة وأوروبيين. يمكنك أيضاً إحضار قماشك الخاص وسنرشدك إلى مدى ملاءمته للموديل المطلوب.'
        },
        fitting: {
          question: 'كم عدد البروفات المقررة؟',
          answer: 'تشمل التعرفة بروفتين وسيطتين، إضافةً إلى البروفة النهائية عند التسليم. وللقطع المعقّدة (كقفطان العروس مثلاً) يمكن إضافة بروفة ثالثة دون رسوم إضافية.'
        },
        alteration: {
          question: 'هل التعديلات مشمولة؟',
          answer: 'تُشمل جميع التعديلات لضبط القياس مجاناً خلال السنة الأولى. بعدها تبقى التعديلات متاحة بسعر تفضيلي لزبائننا.'
        },
        payment: {
          question: 'ما طرق الدفع المتاحة؟',
          answer: 'تسبيق بنسبة 50% يثبّت الطلب عند انتهاء جلسة القياسات، وتُسدَّد البقية عند التسليم. نقبل البطاقة البنكية والتحويل والنقد.'
        },
        cancellation: {
          question: 'هل يمكنني إلغاء الموعد أو تعديله؟',
          answer: 'الإلغاء أو التعديل مجاني حتى 24 ساعة قبل الموعد، عبر الرابط في رسالة التأكيد. بعدها يمكن اقتراح موعد جديد بحسب التوفّر.'
        },
        travel: {
          question: 'هل تتنقّلون إلى منزل الزبون؟',
          answer: 'للأعراس والطلبات الكبيرة (ابتداءً من 3 قطع) نتنقّل دون مقابل داخل الدار البيضاء والرباط ومراكش. خارج هذه المدن قد تُطبَّق رسوم تنقّل.'
        },
        delivery: {
          question: 'هل تشحنون دولياً؟',
          answer: 'نعم، نشحن إلى جميع أنحاء العالم عبر شركات نقل مؤمَّنة. تُحدَّد التكاليف والمواعيد حسب الوجهة وتُبلَّغ عند الطلب.'
        }
      }
    },
    about: {
      title: 'من نحن',
      lead: 'ورشة باريسية صغيرة مكرّسة للحرفية على المقاس.',
      body1: 'نخيط الملابس يدوياً منذ 2014 من أقمشة منتقاة بعناية من أفضل النساجين الإيطاليين والإنجليز. كل قطعة تُقصّ وتُخاط وتُنهى في ورشتنا — بلا إسناد خارجي ولا إنتاج جماعي.',
      body2: 'سواء لحفل زفاف أو الحياة اليومية أو مناسبة كبرى، نأخذ القياسات شخصياً ونعدّل كل تفصيل لقامتك وحركاتك وأسلوبك.',
      valuesTitle: 'قيمنا',
      values: {
        craft: {
          title: 'حرفية يدوية',
          body: 'كل خياطة وكل عروة وبطانة يصنعها خياطون متمرسون بالتقنيات التقليدية.'
        },
        quality: {
          title: 'جودة المواد',
          body: 'نتعامل مع نسّاجين موثوقين منذ سنوات ونرفض أي تنازلات تمس بالملمس أو المتانة.'
        },
        service: {
          title: 'خدمة شخصية',
          body: 'عملاء أقل، اهتمام أكبر. كل قياس يؤخذ بجدية والتعديلات مشمولة مدى الحياة.'
        }
      }
    },
    contact: {
      title: 'اتصل بنا',
      lead: 'أسئلة، طلبات خاصة، أو شراكات — نقرأ كل رسالة.',
      email: 'البريد',
      phone: 'الهاتف',
      address: 'الورشة',
      fields: {
        name: 'اسمك',
        email: 'البريد',
        message: 'الرسالة'
      },
      sending: 'جارٍ الإرسال…',
      send: 'إرسال',
      success: 'شكراً! سنردّ خلال يوم عمل.'
    },
    terms: {
      title: 'الشروط والأحكام',
      updated: 'آخر تحديث: {{date}}',
      sections: {
        scope: {
          title: '1. النطاق',
          body: 'تنظّم هذه الشروط الحجوزات عبر موقعنا وخدمة التفصيل في ورشتنا الباريسية.'
        },
        appointments: {
          title: '2. المواعيد',
          body: 'تُؤكَّد المواعيد عبر البريد. يُرجى الحضور قبل 5 دقائق وإحضار أي قطع مرجعية تودّ مناقشتها.'
        },
        payment: {
          title: '3. الدفع',
          body: 'دفعة مقدّمة 50% لتأكيد طلب التفصيل. الباقي عند التسليم. نقبل البطاقة والتحويل البنكي.'
        },
        cancellation: {
          title: '4. الإلغاء',
          body: 'إلغاء مجاني حتى 24 ساعة قبل الموعد. طلبات التفصيل بعد القصّ غير قابلة للاسترداد، لكن التعديلات مشمولة مدى الحياة.'
        },
        privacy: {
          title: '5. الخصوصية',
          body: 'نجمع فقط المعلومات اللازمة لتقديم الخدمة. لا نبيع بياناتك ولا نشاركها. يمكنك طلب حذفها في أي وقت.'
        },
        liability: {
          title: '6. المسؤولية',
          body: 'نضمن حرفيتنا. عند ظهور عيب خلال 12 شهراً من التسليم، نُصلح أو نستبدل القطعة مجاناً.'
        }
      }
    },
    admin: {
      title: 'المواعيد',
      subtitle: 'راجع وأدر طلبات مواعيد القياس.',
      empty: 'لا توجد مواعيد مطابقة لهذا الفلتر.',
      confirmDelete: {
        title: 'حذف الموعد؟',
        message: 'سيتم حذف هذا الموعد نهائياً. لا يمكن التراجع عن هذا الإجراء.'
      },
      toast: {
        statusUpdated: 'تم تحديث حالة الموعد.',
        deleted: 'تم حذف الموعد.'
      },
      filter: {
        all: 'الكل',
        pending: 'قيد الانتظار',
        confirmed: 'مؤكدة',
        completed: 'منتهية',
        cancelled: 'ملغاة'
      },
      status: {
        pending: 'قيد الانتظار',
        confirmed: 'مؤكد',
        completed: 'منتهي',
        cancelled: 'ملغى'
      },
      table: {
        client: 'العميل',
        product: 'المنتج',
        date: 'التاريخ',
        requested: 'تاريخ الطلب',
        status: 'الحالة',
        actions: 'الإجراءات'
      },
      actions: {
        confirm: 'تأكيد',
        complete: 'تحديد كمنتهي',
        reopen: 'إعادة فتح',
        cancel: 'إلغاء',
        delete: 'حذف'
      },
      search: {
        label: 'بحث',
        placeholder: 'الاسم، البريد، الهاتف…',
        from: 'من',
        to: 'إلى',
        clear: 'مسح الفلاتر'
      },
      pagination: {
        showing: '{{from}}–{{to}} من {{total}}'
      },
      detail: {
        title: 'الموعد',
        client: 'العميل',
        booking: 'الحجز',
        notes: 'الملاحظات',
        notesPlaceholder: 'إضافة ملاحظات داخلية…',
        saveNotes: 'حفظ الملاحظات',
        saving: 'جارٍ الحفظ…',
        notesSaved: 'تم حفظ الملاحظات.',
        timeline: 'السجل الزمني',
        created: 'أُنشئ',
        updated: 'آخر تحديث',
        actions: 'الإجراءات'
      }
    },
    adminProducts: {
      title: 'المنتجات',
      subtitle: 'إنشاء وتعديل وحذف عناصر الكتالوج العام.',
      new: 'منتج جديد',
      empty: 'لا توجد منتجات بعد. أنشئ الأول.',
      i18n: {
        sourceLocaleLabel: 'لغة الإدخال',
        sourceLocaleHint: 'لغة العنوان والوصف أدناه (ما تكتبه).',
        locales: {
          ar: 'العربية',
          fr: 'الفرنسية',
          en: 'الإنجليزية'
        },
        translationsLabel: 'الترجمات',
        translationsHint: 'مولّدة بالذكاء الاصطناعي من المصدر — راجعها قبل الحفظ.',
        translateButton: 'ترجمة (ذكاء اصطناعي)',
        translating: 'جارٍ الترجمة…',
        translated: 'تمت الترجمة ({{count}} لغات) — راجعها قبل الحفظ.',
        errors: {
          needSource: 'أدخل العنوان والوصف المصدر أولاً.',
          empty: 'لم تُرجع خدمة الترجمة أي نتيجة. أعد المحاولة أو أدخل الترجمات يدويًا.'
        }
      },
      confirmDelete: {
        title: 'حذف المنتج؟',
        message: 'حذف « {{title}} »؟ سيختفي من الكتالوج العام.'
      },
      toast: {
        created: 'تم إنشاء المنتج.',
        updated: 'تم تحديث المنتج.',
        deleted: 'تم حذف المنتج.'
      },
      table: {
        product: 'المنتج',
        price: 'السعر',
        duration: 'المدة',
        rating: 'التقييم',
        actions: 'الإجراءات'
      },
      actions: {
        edit: 'تعديل',
        delete: 'حذف'
      },
      fields: {
        title: 'العنوان',
        category: 'الفئة',
        productType: 'طريقة الشراء',
        productTypeHint: 'تفصيل خاص: حجز موعد. جاهز للارتداء: سلة وتوصيل.',
        price: 'السعر',
        originalPrice: 'السعر الأصلي (اختياري)',
        description: 'الوصف',
        image: 'الصورة',
        imageUrl: 'رابط الصورة',
        rating: 'التقييم (0–5)',
        measurementDuration: 'مدة القياس'
      },
      variants: {
        label: 'المقاسات والمخزون',
        sizeLabel: 'المقاس',
        stockLabel: 'المخزون',
        stockSuffix: 'قطعة',
        remove: 'إزالة هذا المقاس',
        hint: 'سطر واحد لكل مقاس. انقري على المقاس لإضافته ثم حددي المخزون.',
        errors: {
          required: 'أضيفي على الأقل مقاساً واحداً (للقطع الجاهزة).',
          invalidRow: 'تحققي من المقاسات والمخزون (المخزون ≥ 0).'
        }
      },
      image: {
        dropOrClick: 'اسحب صورة أو انقر للرفع',
        hint: 'PNG أو JPG أو WEBP، 10 ميجابايت كحدّ أقصى. يمكن أيضاً لصق رابط أدناه.',
        urlPlaceholder: 'أو الصق رابط صورة…',
        sourceLabel: 'الصورة الأصلية',
        sourceHint: 'الصورة التي وُلِّدت منها الصور المعروضة. غير ظاهرة للزبناء.',
        regenerateFromSource: 'إعادة التوليد من الأصل',
        zoom: 'تكبير الصورة',
        zoomClose: 'إغلاق المعاينة',
        primaryHint: 'الصورة الرئيسية (واجهة الكتالوج)',
        errors: {
          notImage: 'الملف المحدّد ليس صورة.',
          tooLarge: 'الصورة كبيرة جداً (10 ميجابايت كحدّ أقصى).',
          required: 'يرجى إضافة صورة (ملف أو رابط).'
        }
      },
      gallery: {
        label: 'معرض الصور',
        add: 'إضافة',
        remove: 'إزالة',
        reorder: 'اسحب لإعادة الترتيب',
        setAsPrimary: 'تعيين كصورة رئيسية',
        imageAlt: 'صورة المعرض رقم {{n}}',
        hint: 'صور إضافية تُعرض في صفحة تفاصيل المنتج. حتى 8 صور. اسحب المقبض لإعادة الترتيب — الصورة الأولى هي الرئيسية للمعرض.',
        errors: {
          full: 'المعرض ممتلئ (الحد الأقصى {{max}} صور). أزل واحدة لإضافة أخرى.'
        }
      },
      form: {
        newTitle: 'منتج جديد',
        editTitle: 'تعديل المنتج',
        cancel: 'إلغاء',
        save: 'حفظ',
        saving: 'جارٍ الحفظ…'
      },
      ai: {
        button: 'تحسين بالذكاء الاصطناعي',
        buttonHint: 'يولّد 4 وضعيات على عارضة بشرية (≈دقيقة، ≈0.16 دولار للمجموعة).',
        title: 'تحسين الصورة بالذكاء الاصطناعي',
        intro: 'سيستبدل الذكاء الاصطناعي المانيكان بصورة بشرية واقعية على خلفية استوديو نظيفة مع الحفاظ على كل تفاصيل التطريز.',
        introSet: 'سينشئ الذكاء الاصطناعي 4 وضعيات مختلفة من الصورة المصدر. احتفظ بما يعجبك، وارفض أو أعد توليد الباقي.',
        setHint1: 'كل وضعية تبرز زاوية مختلفة من الزي (واقفة من الأمام، جالسة، الظهر، ماشية من الجانب).',
        setHint2: 'التكلفة: ≈0.16 دولار للمجموعة، ≈0.04 دولار لإعادة التوليد.',
        keptCount_zero: 'لم يتم الاحتفاظ بأي وضعية',
        keptCount_one: 'تم الاحتفاظ بوضعية واحدة',
        keptCount_other: 'تم الاحتفاظ بـ {{count}} وضعية',
        originalLabel: 'الصورة الأصلية',
        transformedLabel: 'نتيجة الذكاء الاصطناعي',
        placeholder: 'بانتظار…',
        startCta: 'بدء التحويل',
        startSetCta: 'إنشاء 4 وضعيات',
        startNewSet: 'مجموعة جديدة من 4',
        startSetCostHint: 'يولّد 4 وضعيات جديدة (≈0.16 دولار). الصور المحتفظ بها لا تُحذف.',
        resuming: 'جارٍ تحميل الوضعيات الموجودة…',
        finishCta_zero: 'إنهاء',
        finishCta_one: 'إنهاء ({{count}} وضعية)',
        finishCta_other: 'إنهاء ({{count}} وضعية)',
        processing: 'إنشاء…',
        processingHint: 'يستغرق من 15 إلى 30 ثانية.',
        working: 'جارٍ المعالجة…',
        failed: 'فشل.',
        rejected: 'مرفوضة.',
        accept: 'قبول',
        keep: 'احتفاظ',
        kept: 'تم الاحتفاظ',
        keptBadge: 'محتفظ بها',
        reject: 'رفض',
        regenerate: 'إعادة التوليد',
        regenerateCostHint: 'إعادة التوليد تكلّف ≈0.04 دولار.',
        promptEdit: 'تعديل الموجّه',
        promptHide: 'إخفاء الموجّه',
        promptRegenerate: 'إعادة التوليد بهذا الموجّه',
        promptReset: 'استرجاع',
        retry: 'إعادة المحاولة',
        cancel: 'إلغاء',
        close: 'إغلاق',
        poses: {
          STANDING_FRONT: 'واقفة من الأمام',
          SEATED: 'جالسة',
          BACK_OVER_SHOULDER: 'الظهر / نظرة',
          WALKING_SIDE: 'ماشية من الجانب'
        },
        errors: {
          pollTimeout: 'انتهت المهلة — استغرق الإنشاء وقتًا طويلاً. أعد المحاولة أو تواصل مع المسؤول إذا استمرت المشكلة.'
        }
      }
    }
  }
};
